import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialSpyPage() {
    const navigate = useNavigate();
    const [url, setUrl] = useState('');
    const [scanning, setScanning] = useState(false);
    const [scanned, setScanned] = useState(false);

    const handleScan = (e) => {
        e.preventDefault();
        if (!url) return;
        setScanning(true);
        setTimeout(() => {
            setScanning(false);
            setScanned(true);
        }, 2000);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#1e293b', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>

            {!scanned ? (
                // Input State
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <h1 style={{ fontSize: '3rem', marginBottom: 10 }}>🕵️‍♂️ Espion Digital</h1>
                    <p style={{ opacity: 0.6, marginBottom: 40 }}>Qui voulez-vous analyser aujourd'hui ?</p>

                    <form onSubmit={handleScan} style={{ display: 'flex', gap: 10, width: '100%', maxWidth: 500 }}>
                        <input
                            type="text" placeholder="www.concurrent-direct.com" value={url} onChange={e => setUrl(e.target.value)}
                            style={{ flex: 1, padding: '20px', borderRadius: 12, border: 'none', fontSize: '1.2rem', outline: 'none' }}
                        />
                        <button type="submit" disabled={scanning} style={{ padding: '0 30px', borderRadius: 12, border: 'none', background: '#3b82f6', color: 'white', fontSize: '1.5rem', cursor: 'pointer' }}>
                            {scanning ? '...' : '🔍'}
                        </button>
                    </form>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 20, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>Annuler</button>
                </div>
            ) : (
                // Result State (Split Screen)
                <div style={{ flex: 1, display: 'flex', position: 'relative' }}>

                    {/* Floating Header */}
                    <div style={{ position: 'absolute', top: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 10, background: 'black', padding: '10px 30px', borderRadius: 50, fontWeight: 700 }}>
                        VS
                    </div>

                    <button onClick={() => setScanned(false)} style={{ position: 'absolute', top: 20, left: 20, zIndex: 10, background: 'white', color: 'black', border: 'none', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                        ← Nouvelle Recherche
                    </button>

                    {/* Left: Them (Bad) */}
                    <div style={{ flex: 1, background: '#f1f5f9', color: '#334155', padding: 40, borderRight: '2px solid black', overflowY: 'auto' }}>
                        <h2 style={{ color: '#ef4444', fontSize: '2rem', marginBottom: 20 }}>EUX (Ancienne École)</h2>
                        <div style={{ height: 400, background: 'white', border: '1px solid #cbd5e1', borderRadius: 8, padding: 20, opacity: 0.6, filter: 'grayscale(1)' }}>
                            <div style={{ width: '100%', height: 200, background: '#cbd5e1', marginBottom: 20, display: 'grid', placeItems: 'center' }}>IMAGE FLOUE</div>
                            <div style={{ width: '80%', height: 20, background: '#e2e8f0', marginBottom: 10 }}></div>
                            <div style={{ width: '90%', height: 20, background: '#e2e8f0', marginBottom: 10 }}></div>
                            <div style={{ width: '60%', height: 20, background: '#e2e8f0', marginBottom: 10 }}></div>
                            <div style={{ marginTop: 40, padding: 20, background: '#fee2e2', color: '#b91c1c', borderRadius: 8, fontWeight: 700 }}>
                                ⚠️ Pas sécurisé (HTTP)<br />
                                ⚠️ Lent sur mobile<br />
                                ⚠️ Design 2010
                            </div>
                        </div>
                    </div>

                    {/* Right: Us (Good) */}
                    <div style={{ flex: 1, background: '#0f172a', color: 'white', padding: 40, overflowY: 'auto' }}>
                        <h2 style={{ color: '#4ade80', fontSize: '2rem', marginBottom: 20 }}>VOUS (Futur Leader)</h2>
                        <div style={{ height: 400, background: 'linear-gradient(135deg, #1e293b, #334155)', border: '1px solid #475569', borderRadius: 8, padding: 20, boxShadow: '0 20px 50px -10px rgba(0,0,0,0.5)' }}>
                            <div style={{ width: '100%', height: 200, background: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80)', backgroundSize: 'cover', borderRadius: 8, marginBottom: 20 }}></div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: 10 }}>{url ? url.replace('www.', '').split('.')[0].toUpperCase() : 'VOTRE MARQUE'}</div>
                            <p style={{ opacity: 0.7 }}>La référence absolue de votre secteur.</p>
                            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                                <span style={{ padding: '5px 10px', background: '#22c55e', borderRadius: 4, fontSize: '0.8rem', fontWeight: 700 }}>Vitesse: 99/100</span>
                                <span style={{ padding: '5px 10px', background: '#3b82f6', borderRadius: 4, fontSize: '0.8rem', fontWeight: 700 }}>SEO: Top 3</span>
                            </div>
                        </div>
                        <div style={{ marginTop: 40, textAlign: 'center' }}>
                            <button className="cta-pulse" style={{ padding: '20px 40px', background: 'white', color: 'black', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 800, cursor: 'pointer' }}>
                                Écraser la concurrence 🚀
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <style>{`.cta-pulse { animation: pulse 2s infinite; } @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); box-shadow: 0 0 30px rgba(255,255,255,0.3); } 100% { transform: scale(1); } }`}</style>
        </div>
    );
}
